// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3NP5O","insightsList":"newBusinessInsightsMenu_insightsList__1G5W8","active":"newBusinessInsightsMenu_active__3yUJQ"};